import { Components, Theme } from '@mui/material/styles';
import Icon from '~/components/data-display/Icon';
import IconChervonDown from '~/icons/icon-chevron-down.svg?react';
import IconClose from '~/icons/icon-close.svg?react';

export default function Autocomplete(theme: Theme): Partial<Components<Theme>> {
  return {
    MuiAutocomplete: {
      defaultProps: {
        clearIcon: <Icon component={IconClose} data-testid={'autocomplete-clearIcon'} size="sm" />,
        popupIcon: <Icon component={IconChervonDown} size="sm" />,
      },
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z20,
        },
      },
    },
  };
}
